import { baseSoundURL } from '../config';

export type MediaFitMode =
  | 'scale'
  | 'contain'
  | 'cover'
  | 'stretch'
  | 'width'
  | 'height'
  | 'none';

export const normalizeMediaUrl = (url?: string | null) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url) || url.startsWith('//')) {
    return url;
  }
  const separator = url.startsWith('/') ? '' : '/';
  return `${baseSoundURL}${separator}${url}`;
};

export const getMediaBackgroundSize = (
  fitMode: string | null | undefined,
  scale: number | null | undefined
) => {
  const normalizedScale = Number.isFinite(scale) ? (scale as number) : 100;
  switch (fitMode) {
    case 'contain':
      return normalizedScale === 100 ? 'contain' : `${normalizedScale}% ${normalizedScale}%`;
    case 'cover':
      return normalizedScale === 100 ? 'cover' : `${normalizedScale}% ${normalizedScale}%`;
    case 'stretch':
      return normalizedScale === 100 ? '100% 100%' : `${normalizedScale}% ${normalizedScale}%`;
    case 'width':
      return normalizedScale === 100 ? '100% auto' : `${normalizedScale}% auto`;
    case 'height':
      return normalizedScale === 100 ? 'auto 100%' : `auto ${normalizedScale}%`;
    case 'none':
      return normalizedScale === 100 ? 'auto' : `${normalizedScale}% ${normalizedScale}%`;
    case 'scale':
    default:
      return `${normalizedScale}% ${normalizedScale}%`;
  }
};

export const defaultItemIconSettings = {
  iconFitMode: 'scale' as MediaFitMode,
  iconScale: 100,
  iconPositionX: 50,
  iconPositionY: 50
};
